import React from "react";
import "./Reports.css";
import { FaChartBar, FaFileDownload } from "react-icons/fa";

const Reports = () => {
  const reportTypes = [
    { title: "Monthly Attendance Summary", desc: "Detailed breakdown of student attendance percentages per batch." },
    { title: "Fee Collection Ledger", desc: "Financial ledger detailing paid, pending, and overdue accounts." },
    { title: "Admission Enquiry Conversion", desc: "Analytics on lead channels, walk-in conversion rates." },
  ];

  return (
    <div className="reports-container">
      <div className="reports-header">
        <h2><FaChartBar /> Analytics & Reports</h2>
      </div>

      <div className="reports-grid">
        {reportTypes.map((item, idx) => (
          <div key={idx} className="report-card">
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
            <button className="btn-secondary">
              <FaFileDownload /> Export PDF / Excel
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports;